import { render, staticRenderFns } from "./bake_kanban.vue?vue&type=template&id=1186f46a&scoped=true"
import script from "./bake_kanban.vue?vue&type=script&lang=js"
export * from "./bake_kanban.vue?vue&type=script&lang=js"
import style0 from "./bake_kanban.vue?vue&type=style&index=0&id=1186f46a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1186f46a",
  null
  
)

export default component.exports